import AuthModalContainer from './AuthModalContainer';
export default AuthModalContainer;
